<template>
  <q-layout view="hHh lpR fFf">
    <div><img src="../src/assets/Background.jpeg" alt="background_image" width="100%" height="100%"/></div>
    
    <q-header class="c_header q-px-xl" id="header" height-hint="16">
      <q-toolbar>
        <q-toolbar-title>
          <router-link to="/">
          <div class="logo_class"> 
            
            <img src="./assets/Updated_Logo.png" height="55px" width="150px" />
          </div>
          </router-link>
        </q-toolbar-title>
        <div class="headerItems">
          <q-tabs align="center">
            
              
                
                <div class="q-tab__label q-mr-xl"><a class="nav_btn" href="https://uniqinai.substack.com/" target="_blank">Our Blog</a></div>
                <q-page-container>
      <div   v-if="toggle" >
         <router-link to="/" active-class="drawerItems_active" class="drawerItems" exact >
          <div  @click="toggleMenu()" class="menuItemUnlogged">Login/Signup</div>
         </router-link>
          <router-link to="/product" active-class="drawerItems_active" class="drawerItems">
          <div @click="toggleMenu()"  class="menuItemUnlogged">
            Products
          </div>
         </router-link>
          <router-link to="/about" active-class="drawerItems_active" class="drawerItems">
          <div @click="toggleMenu()"  class="menuItemUnlogged">
            About
          </div>
         </router-link>
          <router-link to="/pricing" active-class="drawerItems_active" class="drawerItems">
          <div @click="toggleMenu()"  class="menuItemUnlogged">
            Pricing
          </div>
         </router-link>
        
      </div>
      <router-view />
    </q-page-container>
              
                
                <!-- <div class="q-tab__label q-mr-xl"><a class="nav_btn">Help</a></div> -->
              
            
            <!-- <q-route-tab to="/">
              <div class="col headerItem">
                <img
                  src="./assets/headerLogo/home.svg"
                  height="27px"
                  width="40px"
                />
                <div class="q-tab__label">Home</div>
              </div>
            </q-route-tab>
            <q-route-tab to="/product">
              <div class="col">
                <img
                  src="./assets/headerLogo/received.svg"
                  height="27px"
                  width="30px"
                />
                <div class="q-tab__label">Products</div>
              </div>
            </q-route-tab>
            <q-route-tab to="/about">
              <div class="col">
                <img
                  src="./assets/headerLogo/company.svg"
                  height="27px"
                  width="30px"
                />
                <div class="q-tab__label">About</div>
              </div>
            </q-route-tab>
            <q-route-tab to="/pricing">
              <div class="col">
                <img
                  src="./assets/headerLogo/growth.svg"
                  height="27px"
                  width="30px"
                />
                <div class="q-tab__label">Pricing</div>
              </div>
            </q-route-tab> -->
            <!-- <q-route-tab to="/product" label="Products" />
            <q-route-tab to="/about" label="About" />
            <q-route-tab to="/pricing" label="Pricing" /> -->
            <!-- <div class="col" style="margin-left:1rem">
              <q-btn
                v-if="!$store.state.signedIn"
                type="a"
                :href="signInURL"
                label="Sign In"
                color="blue"
              />
            </div> -->
          </q-tabs>
        </div>
        <!-- <div class="signMobile">
          <q-btn
                v-if="!$store.state.signedIn"
                type="a"
                :href="signInURL"
                label="Sign In"
                color="blue"
              />
        </div> -->
        <div class="hamburger" @click="toggleMenu()">
          <div class="hamStrip"></div>
          <div class="hamStrip"></div>
          <div class="hamStrip"></div>
        </div>
      </q-toolbar>
    </q-header>
    
    <!-- <div>
      <q-footer class="footer">
        <div class="footerHead">
          uniQin.ai
        </div>
        <div class="copyRight">
          Copyright © 2021 uniQin.ai
        </div>
      </q-footer>
    </div> -->
  </q-layout>
</template>
<script>
import awsconfig from "./aws-exports";
export default {
  name: "UnloggedLayout",
  data(){
return{
  toggle:false
}
  },
  methods:{
    toggleMenu(){
      this.toggle =! this.toggle
    }
  },
  computed: {
    signInURL() {
      var client_id = awsconfig.aws_user_pools_web_client_id;
      var justUrl = awsconfig.oauth.domain;
      var cognitoUrl =
        "https://" +
        justUrl +
        "/login?response_type=code&client_id=" +
        client_id +
        "&redirect_uri=";
      var baseURL = window.location.origin + "/auth/signin/";
      console.log(cognitoUrl)
      return cognitoUrl + baseURL;
    },
  },
};
</script>
<style>
  .c_header{
    box-shadow: 0px 3px 6px #29549C47;
  }
  .nav_btn{
    font-size:16px;
    font-weight: 600;
    letter-spacing: 1px;
    color:black;
  }
  #header{
    margin:0px;
    height:150px;
    border-radius:0px;
  }